import { render } from "./VehicleDisplay.vue?vue&type=template&id=79c3201f"
import script from "./VehicleDisplay.vue?vue&type=script&lang=js"
export * from "./VehicleDisplay.vue?vue&type=script&lang=js"

import "./VehicleDisplay.vue?vue&type=style&index=0&id=79c3201f&lang=css"
script.render = render

export default script